import React from 'react';
import { ScoreProvider } from './components/ScoreContext';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { StickyWidget } from './components/StickyWidget';
import { Diagnostic } from './components/Diagnostic';
import { HeroV2 } from './components/v2/HeroV2';
import { BusinessPayoffV2 } from './components/v2/BusinessPayoffV2';
import { Gap } from './components/v2/Gap';
import { QuickCheck } from './components/v2/QuickCheck';
import { Solution } from './components/v2/Solution';
import { PrototypeProof } from './components/v2/PrototypeProof';
import { AuthorLeverage } from './components/v2/AuthorLeverage';
import { ProofScoreCta } from './components/v2/ProofScoreCta';
import { RevenueArchitecture } from './components/v2/RevenueArchitecture';
import { DoneForYou } from './components/v2/DoneForYou';
import { FitInvestment } from './components/v2/FitInvestment';
import { ScoreAuditBuild } from './components/v2/ScoreAuditBuild';
import { FaqFinalCta } from './components/v2/FaqFinalCta';
export function AppV2() {
  return <ScoreProvider data-id="element-16" data-mp="cvg9j6yv4tar">
      <div className="min-h-screen bg-paper font-sans text-text selection:bg-seaglass selection:text-white" data-id="element-17" data-mp="cux24k6u9naz">
        <Nav data-id="element-18" data-mp="hu9qj9dcz2fo" />
        <main data-id="element-19" data-mp="hvulh03l4ne2">
          <HeroV2 data-id="element-20" data-mp="hvb1zeyadqxx" />
          <BusinessPayoffV2 data-id="element-21" data-mp="hsoutgfb5dg8" />
          <Gap data-id="element-22" data-mp="mu5vpbxskzwt" />
          <QuickCheck questionId="q2.intent.handRaiserContext" checkLabel="Quick Check" confirmationText="Saved. This is part of your Reader-to-Revenue Score." data-id="element-23" data-mp="mskzzizqraxd" />
          <Solution data-id="element-24" data-mp="3qacmihv3z2o6" />
          <PrototypeProof data-id="element-25" data-mp="3q9tg9yetm2pz" />
          <AuthorLeverage data-id="element-26" data-mp="3qb4ku0g3bei5" />
          <ProofScoreCta data-id="element-27" data-mp="3q88m49wf4lsn" />
          <RevenueArchitecture data-id="element-28" data-mp="3v9pl1zvcdy6l" />
          <DoneForYou data-id="element-29" data-mp="3v8eejsaiicbs" />
          <FitInvestment data-id="element-30" data-mp="3v84oy5tdq76m" />
          <ScoreAuditBuild data-id="element-31" data-mp="3v7l8yunahsv8" />
          <FaqFinalCta data-id="element-32" data-mp="3v9xzqmq63e8" />
        </main>
        <Footer data-id="element-33" data-mp="3wbg2f25rq5g" />
        <StickyWidget data-id="element-34" data-mp="3wutbigv5qd5" />
        <Diagnostic data-id="element-35" data-mp="32l0ehlbip0ng" />
      </div>
    </ScoreProvider>;
}